import React from 'react';

const Button = ({ 
  variant = 'primary', 
  size = 'md', 
  isActive = true,
  className = '', 
  children, 
  ...props 
}) => {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg';
  
  const variants = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500',
    secondary: isActive 
      ? 'text-white backdrop-blur-sm border' 
      : 'backdrop-blur-sm border',
    danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
    ghost: 'bg-transparent focus:ring-0 focus:ring-offset-0',
    icon: 'p-2 text-white',
  };

  const getVariantStyles = (variant) => {
    if (variant === 'secondary') {
      return isActive
        ? { backgroundColor: 'rgba(39, 39, 42, 0.8)', borderColor: '#3f3f46' }
        : { backgroundColor: 'rgba(239, 68, 68, 0.2)', color: '#f87171', borderColor: 'rgba(239, 68, 68, 0.4)' };
    }
    if (variant === 'ghost') {
      return { color: '#ffffff' };
    }
    if (variant === 'icon') {
      return { color: '#ffffff' };
    }
    return {};
  };

  const sizes = {
    sm: 'px-3 py-1.5 text-xs',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base',
    icon: 'w-10 h-10 md:w-12 md:h-12',
  };

  const variantStyles = getVariantStyles(variant);

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      style={variantStyles}
      onMouseEnter={(e) => {
        if (variant === 'secondary' && isActive) {
          e.currentTarget.style.backgroundColor = 'rgba(63, 63, 70, 0.8)';
        } else if (variant === 'secondary' && !isActive) {
          e.currentTarget.style.backgroundColor = 'rgba(239, 68, 68, 0.3)';
        } else if (variant === 'ghost') {
          e.currentTarget.style.color = '#ffffff';
          e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
        } else if (variant === 'icon') {
          e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
        }
      }}
      onMouseLeave={(e) => {
        if (variant === 'secondary' && isActive) {
          e.currentTarget.style.backgroundColor = 'rgba(39, 39, 42, 0.8)';
        } else if (variant === 'secondary' && !isActive) {
          e.currentTarget.style.backgroundColor = 'rgba(239, 68, 68, 0.2)';
        } else if (variant === 'ghost') {
          e.currentTarget.style.color = '#ffffff';
          e.currentTarget.style.backgroundColor = 'transparent';
        } else if (variant === 'icon') {
          e.currentTarget.style.color = '#ffffff';
        } else if (variant === 'icon') {
          e.currentTarget.style.backgroundColor = 'transparent';
        }
      }}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
